<template>
  <div class="home-redesign home-redesign-variant">
    <main>
      <HrHeroSplitQuick :data="hero" :quick-links="quickLinks" />
      <HrAboutStats :about="about" :stats="stats" />
      <HrDirections :items="directions" />
      <HrReviewsNews :review="review" :news="newsBlock" />
      <HrAdvantages :items="advantages" />
      <HrClosingBanners />
    </main>
  </div>
</template>

<script>
import '@/assets/scss/views/home-redesign.scss'
import '@/assets/scss/views/home-redesign-variants.scss'

import HrHeroSplitQuick from './HrHeroSplitQuick.vue'
import HrAboutStats from '../components/HrAboutStats.vue'
import HrDirections from '../components/HrDirections.vue'
import HrReviewsNews from '../components/HrReviewsNews.vue'
import HrAdvantages from '../components/HrAdvantages.vue'
import HrClosingBanners from '../components/HrClosingBanners.vue'

import {
  heroB,
  quickLinks,
  about,
  stats,
  directions,
  review,
  newsBlock,
  advantages,
} from './variantData'

export default {
  name: 'IndexRedesignB',
  components: {
    HrHeroSplitQuick,
    HrAboutStats,
    HrDirections,
    HrReviewsNews,
    HrAdvantages,
    HrClosingBanners,
  },
  metaInfo() {
    return {
      title: 'Главная B (светлый блок + быстрые ссылки) | Перинатальный центр ДАР',
    }
  },
  data() {
    return {
      hero: heroB,
      quickLinks,
      about,
      stats,
      directions,
      review,
      newsBlock,
      advantages,
    }
  },
  mounted() {
    document.documentElement.style.scrollBehavior = 'smooth'
  },
}
</script>
